import gql from 'graphql-tag';

const CREATE_MILESTONE = gql`
  mutation($projectId: ID!, $input: MilestoneInput) {
    createMilestone(projectId: $projectId, input: $input) {
      milestoneId
      name
      status
      actualEndDate
      totalTasks
      plannedTasks
      inProgressTasks
      blockedTasks
      completedTasks
      overdueTasks
    }
  }
`;

const UPDATE_MILESTONE = gql`
  mutation($milestoneId: ID!, $input: MilestoneInput) {
    updateMilestone(milestoneId: $milestoneId, input: $input) {
      milestoneId
      name
      status
      actualEndDate
      totalTasks
      plannedTasks
      inProgressTasks
      blockedTasks
      completedTasks
      overdueTasks
    }
  }
`;

const DELETE_MILESTONE = gql`
  mutation($milestoneId: ID!) {
    deleteMilestone(milestoneId: $milestoneId)
  }
`;

export { CREATE_MILESTONE, UPDATE_MILESTONE, DELETE_MILESTONE };
